import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { APTContext } from "src/app/services/aptContext/apt-context";
import { waitForEngagementDetailsFetched } from "src/standard/guards/can-match/waitForEngagementDetailsFetched";

export const EngagementDetailsReadyGuard: CanMatchFn = async () => {
  const aptContext = inject(APTContext);
  await waitForEngagementDetailsFetched(aptContext);

  return true;
};
